// Ask.jsx
import React, { useEffect, useRef } from "react";
import "./ask.css";
import { Link } from "react-router-dom";

export const Ask = () => {
  const noBtnRef = useRef(null);
  const btnAreaRef = useRef(null);
  const yesRowRef = useRef(null);

  useEffect(() => {
    const noBtn = noBtnRef.current;
    const btnArea = btnAreaRef.current;
    const yesRow = yesRowRef.current;

    if (!noBtn || !btnArea) return;

    const moveNo = () => {
      const areaRect = btnArea.getBoundingClientRect();
      const btnRect = noBtn.getBoundingClientRect();
      const padding = 10;

      // Reserve the top region where the YES button sits
      const reservedTop = yesRow
        ? yesRow.getBoundingClientRect().bottom - areaRect.top + 12
        : 80; // fallback

      const maxX = Math.max(0, areaRect.width - btnRect.width - padding);
      const maxY = Math.max(
        0,
        areaRect.height - reservedTop - btnRect.height - padding
      );

      const x = Math.max(padding, Math.floor(Math.random() * maxX));
      const y = reservedTop + Math.max(padding, Math.floor(Math.random() * maxY));

      noBtn.style.position = "absolute";
      noBtn.style.left = `${x}px`;
      noBtn.style.top = `${y}px`;
      noBtn.style.transform = "none";

      noBtn.classList.add("panic");
      window.setTimeout(() => noBtn.classList.remove("panic"), 250);
    };

    const onTouchStart = (e) => {
      e.preventDefault();
      moveNo();
    };
    const onMouseEnter = () => moveNo();
    const onClick = (e) => {
      e.preventDefault();
      moveNo();
    };

    // Initial placement safely BELOW the YES row
    const areaRect = btnArea.getBoundingClientRect();
    const reservedTop = yesRow
      ? yesRow.getBoundingClientRect().bottom - areaRect.top + 12
      : 80;

    noBtn.style.position = "absolute";
    noBtn.style.left = "50%";
    noBtn.style.top = `${reservedTop + 40}px`;
    noBtn.style.transform = "translateX(-50%)";

    // Bind events
    noBtn.addEventListener("touchstart", onTouchStart, { passive: false });
    noBtn.addEventListener("mouseenter", onMouseEnter);
    noBtn.addEventListener("click", onClick);

    return () => {
      noBtn.removeEventListener("touchstart", onTouchStart);
      noBtn.removeEventListener("mouseenter", onMouseEnter);
      noBtn.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="val-page">
      <div className="bg-hearts" aria-hidden="true" />

      <main className="wrap">
        <section className="card" aria-label="Valentine question card">
          <div className="badge">Hello Spoiler 😜</div>

          <h1 className="title">
            Will you be my <span className="shine">Valentine</span>? 💘
          </h1>

          <p className="subtitle">
            I’m asking with a tiny bit of drama and my whole heart … that’s been yours for a while 😍
          </p>

          <div className="sticker-row" aria-hidden="true">
            <span className="sticker">💖</span>
            <span className="sticker">🌹</span>
            <span className="sticker">✨</span>
            <span className="sticker">🧸</span>
          </div>

          <div className="btn-area" ref={btnAreaRef} aria-label="Buttons area">
            <div className="yes-row" ref={yesRowRef}>
              <Link className="btn yes" to="/valentine/yes">
                Yes! 💞
              </Link>
            </div>

            <button className="btn no" ref={noBtnRef} type="button">
              No 😅
            </button>
          </div>

          <p className="tiny">(Don't you dare think of No… 😏)</p>
        </section>

        <footer className="footer">
          <span>Made with ❤️ by Pradeep</span>
        </footer>
      </main>
    </div>
  );
};

export default Ask;
